import {faBug} from "@fortawesome/pro-solid-svg-icons/faBug";
import {faLanguage} from "@fortawesome/pro-solid-svg-icons/faLanguage";
import {faLocationPinSlash} from "@fortawesome/pro-solid-svg-icons/faLocationPinSlash";
import {ItemMenuEntry, useLayout} from "@twigsby/frontend-framework";
import React from "react";
import {useTranslation} from "@twigsby/frontend-framework";
import {useNavigate} from "react-router-dom";
import {useSite} from "../Providers/SiteInterfaceProvider";

const SiteDevMenu = () => {
    const navigate = useNavigate();
    const { updateLanguage } = useSite();
    const { updateDirection } = useLayout();

    const UpdateLanguage = (locale: string, rtl: boolean) => {
        updateDirection(rtl ? 'rtl' : 'ltr');
        updateLanguage(locale);
    }

    return (
        <>
            <ItemMenuEntry icon={faLanguage} title="Languages">
                <ItemMenuEntry title="English" onClick={() => UpdateLanguage('en', false)} />
                <ItemMenuEntry title="日本語" onClick={() => UpdateLanguage('jp', true)} />
                <ItemMenuEntry title="None" onClick={() => UpdateLanguage('none', false)} />
            </ItemMenuEntry>
            <ItemMenuEntry title={'Divider'} sectionDivider={true} />
            <ItemMenuEntry title={'404'} icon={faLocationPinSlash} onClick={() => navigate('/path-to-nowhere')} />
            <ItemMenuEntry title={'Trigger Sentry'} icon={faBug} onClick={() => navigate('/error')} />
        </>
    )
}

export { SiteDevMenu }
